import { JobPost } from '../types';

export const isJobPostExpired = (jobPost: Partial<JobPost>): boolean =>
    !jobPost.deadlineAt || Date.now() >= jobPost.deadlineAt;
